const angular = require('angular');
var app = angular.module('learn-controllers');
const moment = require('moment');
/**
 * Import CSV Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 */
app.filter('categoryName', function() {
  return function(input) {
    return !input ? '' : typeof input === 'string' ? input.split('---')[0] : '';
  };
}).controller('usersCsv', ['Application', 'Authorization', 'AccessHelper', '$scope', '$http', 'Proliferation', 'ProliferationNew', '$translate', function (Application, Authorization, AccessHelper, $scope, $http, Proliferation, ProliferationNew, $translate) {
  var self = this;
  self.flags = Application.features.flags();

  self.allowance = {
    add: AccessHelper.isAllowed(['admin', 'users', 'bulk_add'], null, ['admin', 'manager'])
  };

  if (!self.allowance.add) {
    Application.navigation.goTo('/explore');
    return;
  }

  self.translations = {};
  self.file;
  self.activeTab = 'select';
  self.loading = false;

  self.select = {
    name: null,
    uploadId: 'open-browse',
    openBrowse: function() {
      document.getElementById(this.uploadId).click();
    },
    upload: function() {
      if (this.name === self.file.name) {
        return;
      }
    },
    next: function() {
      if (!self.file) {
        Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.useradd.missing_csv']});
        return;
      }
      if (self.file.name && this.name && self.file.name === this.name) {
        self.activeTab = 'match';
        return;
      }

      this.name = self.file.name;
      var formData = new FormData();
      formData.append('file', self.file);
      self.loading = true;

      $http.post(Application.API + '/learn/v3/proliferation' + (self.flags.proliferation_new ? '-new' : '') + '/initial', formData, {
        withCredentials : false,
        headers : {
         'Content-Type' : undefined
        },
        transformRequest : angular.identity
      }).then(function(response) {
        var data = response.data;
        self.loading = false;
        self.match.providedFields = data.fields;
        self.match.newUsers = !!data.newUsers;
        self.match.set();
        self.activeTab = 'match';
        self.match.tryautomatch();
        Application.scrollTop();
      }).catch(function(response) {
        self.loading = false;
        var data = response.data;
        if (response.status !== 200) {
          if (response.status === 409) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.useradd.duplicate_rows']});
            return;
          }
          Application.messaging.addMessage({type: 'error', duration: 5, text: (data && data.message ? data.message.substr(data.message.lastIndexOf(':') + 1) : 'Unable to process file.')});
          return;
        }
      });
    }
  };

  $scope.$watch('csv.file', function(newVal, oldVal) {
    oldVal = oldVal || {};
    if (!newVal || typeof newVal !== 'object') {
      return;
    }
    if (newVal.name && newVal.name !== oldVal.name) {
      Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['edit.useradd.success_csv']});
    }
  });

  self.match = {
    totalMandatory: 4,
    completedMandatory: 0,
    remainingMandatory: [],
    dropDowns: {},
    providedFields: {},
    headingMatch: {},
    newUsers: true,
    filterLimit: 3,
    back: function() {
      if (self.activeTab !== 'match') {
        return;
      }
      self.activeTab = 'select';
    },
    set: function(newUsers) {
      this.totalMandatory = 4;
      this.completedMandatory = 0;
      this.remainingMandatory = [];
      this.dropDowns = {};
      this.headingMatch = {};
      this.filterLimit = 3;

      for (var key in this.providedFields) {
        this.headingMatch[key] = false;
      }
      this.setMandatory();
    },
    tryautomatch: function() {
      for(var field in this.providedFields) {
        for(var heading in this.availableHeadings) {
          if(field === heading) {
            this.pair(field, heading, true);
          }
        }
      }
      this.checkEmails();
    },
    getMandatory: function(){
      return ['first_name', 'last_name', 'email', 'provisioning_status'];
    },
    setMandatory: function() {
      this.totalMandatory = this.newUsers ? 4 : 1;
      var mandates = this.newUsers ? this.getMandatory(): ['email'];
      for (var key in this.headingMatch) {
        var item = this.headingMatch[key];
        if (item && mandates.indexOf(item) > -1) {
          mandates.splice(mandates.indexOf(item), 1);
        }
      }
      this.completedMandatory = this.totalMandatory - mandates.length;
      this.remainingMandatory = mandates;
    },
    pair: function(userField, continuField, hold) {
      for (var key in this.headingMatch) {
        if (continuField && this.headingMatch[key] === continuField) {
          this.headingMatch[key] = false;
        }
      }
      this.headingMatch[userField] = continuField;
      if (!hold && (continuField === 'email' || continuField === 'userid')) {
        this.checkEmails();
      }
      this.setMandatory();
      this.dropDowns[userField] = false;
    },
    checkEmails: function() {
      self.loading = true;
      var check = '';
      for (var heading in this.headingMatch) {
        if (this.headingMatch[heading] === 'email') {
          check += ',email,' + heading;
        }
        if (this.headingMatch[heading] === 'userid') {
          check += ',userid,' + heading;
        }
      }
      if (!check.length) {
        return;
      }

      check = check.slice(1);

      var formData = new FormData();
      formData.append('file', self.file);
      formData.append('fieldMap', check);

      $http.post(Application.API + '/learn/v3/proliferation' + (self.flags.proliferation_new ? '-new' : '') + '/email-check', formData, {
        withCredentials : false,
        headers : {
         'Content-Type' : undefined
        },
        transformRequest : angular.identity
      }).then(function(response) {
        self.loading = false;
        var data = response.data;
        self.match.newUsers = data.newUsers;
        self.match.setMandatory();
      }).catch(function(response) {
        self.loading = false;
        var data = response.data;
        if (response.status !== 200) {
          if (response.status === 409) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.useradd.duplicate_rows']});
            return;
          }
          Application.messaging.addMessage({type: 'error', duration: 5, text: (data && data.message ? data.message.substr(data.message.lastIndexOf(':') + 1) : 'Unable to process file.')});
          return;
        }
      });
    },
    next: function () {
      if (this.completedMandatory !== this.totalMandatory) {
        Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.useradd.assign_fields']});
        return;
      }
      self.preview.set();
      self.match.nextLoading = true;
    }
  };

  self.preview = {
    creates: [],
    updates: [],
    deletes: [],
    rests: [],
    reinvites: [],
    migrations_i2p: [],
    migrations_p2i: [],
    errors: [],
    pending: [],
    createList: [],
    updateList: [],
    errorList: [],
    pendingList: [],
    newLocations: [],
    newDepartments: [],
    newTeams: [],
    newOrgLevels: [],
    newGrades: [],
    locationOptions: {},
    departmentOptions: {},
    teamOptions: {},
    org_levelOptions: {},
    gradeOptions: {},
    getGroups: false,
    dropdownFields: {
      role: true,
      location_1: true,
      location_2: true,
      location_3: true,
      department_1: true,
      department_2: true,
      department_3: true,
      team: true,
      org_level: true,
      grade: true,
      provisioning_status: true
    },
    checkNew: true,
    checkUpdate: true,
    showConfirm: false,
    openDrop: false,
    createsTable: false,
    updatesTable: false,
    errorsTable: false,
    pendingTable: false,
    editType: '',
    editIndex: '',
    editOriginal: '',
    editOriginal2: '',
    editOriginal3: '',
    editKey: '',
    editOptions: [],
    confirmBack: false,
    checkError: function(key, item) {
      if (item.errors && item.errors.length && (item.errors.indexOf(key) !== -1 || item.errors.indexOf('no_changes') !== -1)) {
        return true;
      }
      return false;
    },
    askBack: function() {
      if (self.activeTab !== 'preview') {
        return;
      }
      this.confirmBack = true;
    },
    back: function() {
      this.checkNew = true;
      this.checkUpdate = true;
      this.showConfirm = false;
      this.creates = [];
      this.updates = [];
      this.errors = [];
      this.pending = [];
      this.createList = [];
      this.updateList = [];
      this.errorList = [];
      this.pendingList = [];
      this.newLocations = [];
      this.newDepartments = [];
      this.newTeams = [];
      this.newOrgLevels = [];
      this.newGrades = [];
      this.locationOptions = {};
      this.departmentOptions = {};
      this.teamOptions = {};
      this.org_levelOptions = {};
      this.gradeOptions = {};
      this.editOptions = [];
      this.openDrop = false;
      this.createsTable = false;
      this.updatesTable = false;
      this.errorsTable = false;
      this.pendingTable = false;
      this.confirmBack = false;
      this.editType = '';
      this.editIndex = '';
      this.editOriginal = '';
      this.editOriginal2 = '';
      this.editOriginal3 = '';
      this.editKey = '';
      self.activeTab = 'match';
    },
    createOptions: function() {
      var roles = ['admin', 'user', 'creator'];
      if(Authorization.getAuthToken().company.external_users) {
        roles.push('external');
      }
      if (this.editKey === 'role') {
        this.editOptions = roles;
        return;
      }
      var provisioning_statuses = ['inviting', 'provisioning', 'inviting-muted', 'provisioning-muted', 'resetting', 'reinviting', 'deleting', 'migrating-2-provisioning', 'migrating-2-inviting'];
      if (this.editKey === 'provisioning_status') {
        this.editOptions = provisioning_statuses;
        return;
      }

      var users = this.editType === 'create' ? this.createList : this.editType === 'update' ? this.updateList : this.errorList;
      var user = users[this.editIndex];
      var fields = this.editKey.split('_');
      var options = {topLevelOptions: []};
      if(fields[0] === 'location') {
         options = this.locationOptions;
      }
      if(fields[0] === 'department') {
         options = this.departmentOptions;
      }
      if(fields[0] === 'team') {
         options = this.teamOptions;
      }
      if(fields[0] === 'org_level') {
         options = this.org_levelOptions;
      }
      if(fields[0] === 'grade') {
         options = this.gradeOptions;
      }

      switch (fields[1]) {
        case '1':
          this.editOptions = options['topLevelOptions'];
          if (user[fields[0] + '_2']) {
            this.editOriginal2 = user[fields[0] + '_2'];
          }
          if (user[fields[0] + '_3']) {
            this.editOriginal3 = user[fields[0] + '_3'];
          }
          return;
        case '2':
          this.editOptions = options[user[fields[0] + '_1']] || [];
          if (user[fields[0] + '_3']) {
            this.editOriginal3 = user[fields[0] + '_3'];
          }
          return;
        case '3':
          this.editOptions = options[user[fields[0] + '_1'] + '---' + user[fields[0] + '_2']] || [];
          return;
        default:
          break;
      }

    },
    editOptionSelect: function(item) {
      var users = this.editType === 'create' ? this.createList : this.editType === 'update' ? this.updateList : this.errorList;
      var user = users[this.editIndex];

      user[this.editKey] = item;
      this.openDrop = false;
      if (this.editKey === 'role' || this.editKey === 'provisioning_status') {
        return;
      }

      var fields = this.editKey.split('_');
      if (!fields[1]) {
        return;
      }
      switch (fields[1]) {
        case '1':
          if (user[this.editKey] === this.editOriginal) {
            return;
          }
          user[fields[0] + '_2'] = '';
          user[fields[0] + '_3'] = '';
          return;
        case '2':
          if (user[this.editKey] === this.editOriginal) {
            return;
          }
          user[fields[0] + '_3'] = '';
          return;
        case '3':
        default:
          break;
      }

    },
    editField: function(type, index, original, field) {
      if (this.editType) {
        var typeSection = type === 'create' ? self.translations['edit.useradd.new_users'] : type === 'update' ? self.translations['edit.useradd.updated_users'] : self.translations['edit.useradd.errored_users'];
        var message = $translate('edit.useradd.cancel_confirm', { selection: typeSection });
        Application.messaging.addMessage({type: 'error', duration: 5, text: message});
        return;
      }
      this.editType = type;
      this.editIndex = index;
      this.editOriginal = original;
      this.editKey = field;
      if (this.dropdownFields[field]) {
        this.createOptions();
      }
    },
    cancelEdit: function(type, item, field) {
      var splitField;
      item[field] = this.editOriginal;
      this.editType = '';
      this.editIndex = '';
      this.editOriginal = '';
      this.editKey = '';
      this.editOptions = [];
      if (this.editOriginal2) {
        splitField = field.split('_');
        item[splitField[0] + '_2'] = this.editOriginal2;
        this.editOriginal2 = '';
      }
      if (this.editOriginal3) {
        splitField = field.split('_');
        item[splitField[0] + '_3'] = this.editOriginal3;
        this.editOriginal3 = '';
      }
    },
    submitEdit: function(type, item, field, index) {
      var list;
      var message;
      self.loading = true;
      Proliferation.edit({user: item}).$promise
      .then(function(result) {
        if (result._id) {
          item._id = result._id;
        }
        var noChange;
        var pendingSwitch;
        var validity = result.validity;
        var association = {
          create: {
            update: 'update',
            errored: 'error',
            new: false,
            pending: 'pending'
          },
          update: {
            update: false,
            errored: false,
            new: 'create',
            pending: 'pending'
          },
          error: {
            update: 'update',
            errored: false,
            new: 'create',
            pending: 'pending'
          }
        };
        if (association[type] && association[type][validity]) {
          message = {type: 'success', duration: 8, text: ''};

          if (association[type][validity] === 'create' || association[type][validity] === 'update') {
            delete item.errored;
            message.text = association[type][validity] === 'create' ? self.translations['edit.useradd.edited_valid'] : self.translations['edit.useradd.created_valid'];
            var removalList = type === 'create' ? self.preview.creates : type === 'update' ? self.preview.updates : self.preview.errors;
            var additionList = validity === 'new' ? self.preview.creates : validity === 'update' ? self.preview.updates : self.preview.errors;
            for (var i = 0; i < additionList.length; i++) {
              if (additionList[i].email && additionList[i].email === item.email) {
                pendingSwitch = true;
                removalList.splice(self.preview.navigation.trueIndex(type, index), 1);
              }
            }
            if (!pendingSwitch) {
              removalList.splice(self.preview.navigation.trueIndex(type, index), 1);
              additionList.unshift(item);
            }
            self.preview.navigation.set();
          }

          if (pendingSwitch) {
            message.text = type === 'create' ? self.translations['edit.useradd.already_updated'] : self.translations['edit.useradd.already_updated'];
            message.type = 'information';
          }

          if (association[type][validity] === 'error') {
            noChange = true;
            message.text = self.translations['edit.useradd.invalid_entry'];
            message.type = 'error';
          }

          if (association[type][validity] === 'pending') {
            message.text = self.translations['edit.useradd.pending_invite'];
            message.type = 'information';
            var removalList = type === 'create' ? self.preview.creates : type === 'update' ? self.preview.updates : self.preview.errors;
            var additionList = self.preview.pendings;
            removalList.splice(self.preview.navigation.trueIndex(type, index), 1);
            additionList.unshift(item);
            self.preview.navigation.set();
          }
        }

        if (type === 'update' && result.validity === 'errored') {
          if (result.errors && result.errors[0] === 'missing') {
            item.errored = true;
            message = null;
          }
        }

        if (message) {
          Application.messaging.addMessage(message);
        }

        if (noChange) {
          self.loading = false;
          return;
        }

        self.preview.editType = '';
        self.preview.editIndex = '';
        self.preview.editOriginal = '';
        self.preview.editOriginal2 = '';
        self.preview.editOriginal3 = '';
        self.preview.editKey = '';
        self.preview.editOptions = [];
        self.loading = false;
      });
    },
    set: function () {
      var list = '';
      for (var userField in self.match.headingMatch) {
        list += ',' + self.match.headingMatch[userField] + ',' + userField;
      }
      list = list.slice(1);

      var formData = new FormData();
      formData.append('file', self.file);
      formData.append('fieldMap', list);
      self.loading = true;

      $http.post(Application.API + '/learn/v3/proliferation' + (self.flags.proliferation_new ? '-new' : '') + '/validation', formData, {
        withCredentials : false,
        headers : {
         'Content-Type' : undefined
        },
        transformRequest : angular.identity
      }).then(function(response) {
        var data = response.data;
        self.preview.getGroups = data.getGroups || false;
        self.preview.createCategoryOptions(data.existingCategoryDirectory, data.newCategoryDirectory);
        self.preview.organize(data.results);
        self.preview.navigation.set();
        self.match.nextLoading = false;
        self.activeTab = 'preview';
        self.loading = false;
        Application.scrollTop();
      }).catch(function(response) {
        self.loading = false;
        var data = response.data;
        if (response.status !== 200) {
          if (response.status === 409) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.useradd.user_seats_limit_met']});
            return;
          }
          Application.messaging.addMessage({type: 'error', duration: 5, text: (data.message ? data.message.substr(data.message.lastIndexOf(':') + 1) : 'Unable to process file.')});
          return;
        }
      });
    },
    organize: function(data) {
      for (var key in data) {
        switch (key) {
          case 'create':
            this.creates = data[key];
            break;
          case 'update':
            this.updates = data[key];
            break;
          case 'errored':
            this.errors = data[key];
            break;
          case 'pending':
            this.pendings = data[key];
            break;
          case 'reinvite':
            this.reinvites = data[key];
            break;
          case 'migrations_i2p':
            this.migrations_i2p = data[key];
            break;
          case 'migrations_p2i':
            this.migrations_p2i = data[key];
            break;
          case 'reset':
            this.resets = data[key];
            break;
          case 'delete':
            this.deletes = data[key];
            break;
          case 'locations':
            this.newLocations = data[key];
            break;
          case 'departments':
            this.newDepartments = data[key];
            break;
          case 'teams':
            this.newTeams = data[key];
            break;
          case 'org_levels':
            this.newOrgLevels = data[key];
            break;
          case 'grades':
            this.newGrades = data[key];
            break;
          default:
            break;
        }
      }
    },
    createCategoryOptions: function(existing, created) {
      var sortCategories = function(options, storage) {
        for (var key in options) {
          var items = key.split('---');
          var item = items[0];
          var parent = items[1];
          if (parent && items[2]) {
            parent = parent + '---' + items[2];
          }
          if (!parent) {
            parent = 'topLevelOptions';
          }
          if (!storage[item]) {
            storage[item] = [];
          }
          if (parent) {
            if (!storage[parent]) {
              storage[parent] = [];
            }
            storage[parent].push(item);
          }
        }
      };
      sortCategories(existing.locations, this.locationOptions);
      sortCategories(created.locations, this.locationOptions);
      sortCategories(existing.departments, this.departmentOptions);
      sortCategories(created.departments, this.departmentOptions);
      sortCategories(existing.teams, this.teamOptions);
      sortCategories(created.teams, this.teamOptions);
      sortCategories(existing.org_levels, this.org_levelOptions);
      sortCategories(created.org_levels, this.org_levelOptions);
      sortCategories(existing.grades, this.gradeOptions);
      sortCategories(created.grades, this.gradeOptions);
    },
    navigation: {
      per_page: 5,
      set: function() {
        this.create.totalPages = Math.ceil(self.preview.creates.length / this.per_page) - 1;
        if (this.create.totalPages > 0) {
          this.create.currentPage = 0;
          this.create.allowNext = true;
        }
        this.update.totalPages = Math.ceil(self.preview.updates.length / this.per_page) - 1;
        if (this.update.totalPages > 0) {
          this.update.currentPage = 0;
          this.update.allowNext = true;
        }
        this.error.totalPages = Math.ceil(self.preview.errors.length / this.per_page) - 1;
        if (this.error.totalPages > 0) {
          this.error.currentPage = 0;
          this.error.allowNext = true;
        }
        this.pending.totalPages = Math.ceil(self.preview.pendings.length / this.per_page) - 1;
        if (this.pending.totalPages > 0) {
          this.pending.currentPage = 0;
          this.pending.allowNext = true;
        }
        this.reset('create');
        this.reset('update');
        this.reset('error');
        this.reset('pending');
      },
      create: {
        currentPage: 0,
        totalPages: 0,
        allowPrevious: false,
        allowNext: false
      },
      update: {
        currentPage: 0,
        totalPages: 0,
        allowPrevious: false,
        allowNext: false
      },
      error: {
        currentPage: 0,
        totalPages: 0,
        allowPrevious: false,
        allowNext: false
      },
      pending: {
        currentPage: 0,
        totalPages: 0,
        allowPrevious: false,
        allowNext: false
      },
      trueIndex: function(type, index) {
        var currentPage = this[type].currentPage;
        return currentPage * this.per_page + index;
      },
      next: function(type) {
        if (this[type] && this[type].allowNext) {
          this[type].currentPage++;
          if (this[type].currentPage >= this[type].totalPages) {
            this[type].allowNext = false;
          }
          this[type].allowPrevious = true;
          this.reset(type);
        }
      },
      previous: function(type) {
        if (this[type] && this[type].allowPrevious) {
          this[type].currentPage--;
          if (this[type].currentPage <= 0) {
            this[type].allowPrevious = false;
          }
          this[type].allowNext = true;
          this.reset(type);
        }
      },
      reset: function(type) {
        self.preview[type + 'List'] = self.preview[type + 's'].slice(this[type].currentPage * this.per_page, this[type].currentPage * this.per_page + this.per_page);
      }
    },
    import: function() {
      var creates = self.preview.checkNew ? self.preview.creates : [];
      var updates = self.preview.checkUpdate ? self.preview.updates : [];
      self.preview.importLoading = true;
      self.loading = true;

      (self.flags.proliferation_new ? ProliferationNew : Proliferation).final({create: creates, update: updates, locations: self.preview.newLocations, departments: self.preview.newDepartments, teams: self.preview.newTeams, org_levels: self.preview.newOrgLevels, grades: self.preview.newGrades, getGroups: self.preview.getGroups || false}).$promise
      .then(function(result) {
        self.review.createdUsers = result.createdUsers.concat(self.review.createdUsers);
        self.review.invitations = [];
        self.review.preprovisions = [];
        self.review.createdUsers.forEach(function (user) {
          if(user.provisioning_status && user.provisioning_status === 'inviting') {
            self.review.invitations.push(user);
          }
          if(user.provisioning_status && user.provisioning_status === 'provisioning') {
            self.review.preprovisions.push(user);
          }
        });
        self.review.updatedUsers = result.createdUpdates;
        self.review.resettings = result.createdResettings.message?result.createdResettings.message:null;
        self.review.reinvitations = result.createdReinvitings.message?result.createdReinvitings.message:null;
        self.review.deletedUsers = result.createdDeletions.deleted?result.createdDeletions.deleted:[];
        self.review.newCategories = result.createdCategories;
        self.review.categoryDirectory = result.categoryDirectory;
        self.review.navigation.set();
        self.preview.showConfirm = false;
        self.preview.importLoading = false;
        self.loading = false;
        self.activeTab = 'review';
        Application.scrollTop();
      }).catch(function(error) {
        self.loading = false;
        console.log('error: ', error);
      });
    }
  };

  if (self.flags.groups) {
    self.preview.dropdownFields.groups = true;
    self.preview.dropdownFields.managing_groups = true;
  }

  self.review = {
    invitations: [],
    preprovisions: [],
    createdUsers: [],
    updatedUsers: [],
    deletedUsers: [],
    migrationsI2P: [],
    migrationsP2I: [],
    reinvitations: null,
    resettings: null,
    inviteList: [],
    preprovisionList: [],
    updateList: [],
    newCategories: [],
    categoryDirectory: [],
    navigation: {
      per_page: 5,
      set: function() {
        this.invite.totalPages = Math.ceil(self.review.invitations.length / this.per_page) - 1;
        if (this.invite.totalPages > 0) {
          this.invite.currentPage = 0;
          this.invite.allowNext = true;
        }
        this.preprovision.totalPages = Math.ceil(self.review.preprovisions.length / this.per_page) - 1;
        if (this.preprovision.totalPages > 0) {
          this.preprovision.currentPage = 0;
          this.preprovision.allowNext = true;
        }
        this.update.totalPages = Math.ceil(self.review.updatedUsers.length / this.per_page) - 1;
        if (this.update.totalPages > 0) {
          this.update.currentPage = 0;
          this.update.allowNext = true;
        }
        this.reset('invite');
        this.reset('preprovision');
        this.reset('update');
      },
      invite: {
        currentPage: 0,
        totalPages: 0,
        allowPrevious: false,
        allowNext: false
      },
      preprovision: {
        currentPage: 0,
        totalPages: 0,
        allowPrevious: false,
        allowNext: false
      },
      update: {
        currentPage: 0,
        totalPages: 0,
        allowPrevious: false,
        allowNext: false
      },
      trueIndex: function(type, index) {
        var currentPage = this[type].currentPage;
        return currentPage * this.per_page + index;
      },
      next: function(type) {
        if (this[type] && this[type].allowNext) {
          this[type].currentPage++;
          if (this[type].currentPage >= this[type].totalPages) {
            this[type].allowNext = false;
          }
          this[type].allowPrevious = true;
          this.reset(type);
        }
      },
      previous: function(type) {
        if (this[type] && this[type].allowPrevious) {
          this[type].currentPage--;
          if (this[type].currentPage <= 0) {
            this[type].allowPrevious = false;
          }
          this[type].allowNext = true;
          this.reset(type);
        }
      },
      reset: function(type) {
        var collection = []; 
        if(type === 'invite') {
          collection = self.review.invitations;
        }
        if(type === 'preprovision') {
          collection = self.review.preprovisions;
        }
        if(type === 'update') {
          collection = self.review.updatedUsers;
        }
        self.review[type + 'List'] = collection.slice(this[type].currentPage * this.per_page, this[type].currentPage * this.per_page + this.per_page);
      }
    },
    getCategory: function(item, key) {
      if (!item || !key || !item.length) {
        return '';
      }
      var id = item[0];
      var type = key.split('_')[1];
      if (this.categoryDirectory[type] && this.categoryDirectory[type][id] && this.categoryDirectory[type][id].name) {
        return this.categoryDirectory[type][id].name;
      }

      return '';
    },
    done: function() {
      Application.navigation.goTo('/overview/users');
    },
    showImport: false,
    submitEdit: function(type, item, field, index) {
      var message;
      var checkEdited = function() {
        for (var i = 0; i < self.preview.errors.length; i++) {
          if (self.preview.errors[i].editedValidity) {
            return true;
          }
        }
        return false;
      };
      self.loading = true;

      Proliferation.edit({user: item}).$promise
      .then(function(result) {
        if (result._id) {
          item._id = result._id;
        }
        var validity = result.validity;
        var noChange;
        if (validity === 'errored') {
          if (!result.errors || result.errors.length !== 1 || result.errors[0] !== 'missing') {
            message = {type: 'error', duration: 6, text: self.translations['edit.useradd.invalid_entry']};
            noChange = true;
          }
          item.editedValidity = false;
          self.review.showImport = checkEdited();
        }

        if (validity === 'update' || validity === 'new') {
          item.editedValidity = validity;
          self.review.showImport = true;
          var verb = validity === 'new' ? self.translations["global.actions.added"] : self.translations["global.actions.updated"];
          message = {type: 'success', duration: 6, text: $translate('edit.useradd.success_verb', { verb: verb })};
        }

        if (validity === 'pending') {
          message = {type: 'information', duration: 6, text: self.translations['edit.useradd.pending_invite']};
          self.review.showImport = checkEdited();
          self.preview.errors.splice(self.preview.navigation.trueIndex(type, index), 1);
          self.preview.pendings.unshift(item);
          self.preview.navigation.set();
        }

        if (message) {
          Application.messaging.addMessage(message);
        }

        if (noChange) {
          self.loading = false;
          return;
        }

        self.preview.editType = '';
        self.preview.editIndex = '';
        self.preview.editOriginal = '';
        self.preview.editOriginal2 = '';
        self.preview.editOriginal3 = '';
        self.preview.editKey = '';
        self.preview.editOptions = [];
        self.loading = false;
      });
    },
    importChanges: function() {
      var creates = [];
      var updates = [];

      for (var i = self.preview.errors.length - 1; i >=0; i--) {
        if (self.preview.errors[i].editedValidity) {
          if (self.preview.errors[i].editedValidity === 'new') {
            var user = self.preview.errors.splice(i, 1)[0];
            delete user.editedValidity;
            delete user.errors;
            creates.push(user);
          }
          if (self.preview.errors[i].editedValidity === 'update') {
            var user = self.preview.errors.splice(i, 1)[0];
            delete user.editedValidity;
            delete user.errors;
            updates.push(user);
          }
        }
      }

      self.loading = true;
      
      (self.flags.proliferation_new ? ProliferationNew : Proliferation).final({create: creates, update: updates, locations: [], departments: [], teams: [], org_levels: [], grades: [], getGroups: self.preview.getGroups || false}).$promise
      .then(function(result) {
        self.review.createdUsers = result.createdUsers.concat(self.review.createdUsers);
        self.review.invitations = [];
        self.review.preprovisions = [];
        self.review.createdUsers.forEach(function (user) {
          if(user.provisioning_status && user.provisioning_status === 'inviting') {
            self.review.invitations.push(user);
          }
          if(user.provisioning_status && user.provisioning_status === 'provisioning') {
            self.review.preprovisions.push(user);
          }
        });
        self.review.updatedUsers = result.createdUpdates.concat(self.review.updatedUsers);
        self.review.resettings = result.createdResettings.message?result.createdResettings.message:null;
        self.review.reinvitations = result.createdReinvitings.message?result.createdReinvitings.message:null;
        self.review.deletedUsers = result.createdDeletions.deleted?result.createdDeletions.deleted:[];
        self.review.migrationsI2P = result.createdMigrationsI2P || [];
        self.review.migrationsP2I = result.createdMigrationsP2I || [];
        self.review.navigation.set();
        self.preview.navigation.set();
        self.review.showImport = false;
        self.loading = false;
        Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['edit.useradd.success_implement']});
        Application.scrollTop();
      }).catch(function(error) {
        self.loading = false;
        console.log('error: ', error);
      });
    },
    downloadCsv: function(items, name) {
      items = items || self.preview.errors;
      name = name || 'errored';
      var headings = Object.keys(self.match.availableHeadings);
      var data = [headings];
      for (var i = 0; i < items.length; i++) {
        var item = [];
        for (var j = 0; j < headings.length; j++) {
          var value = items[i][headings[j]] || '';
          if (value && typeof value === 'string' && value.indexOf(',') !== -1) {
            value = '"' + value + '"';
          }
          item.push(value);
        }
        data.push(item);
      }

      var csvContent = "data:text/csv;charset=utf-8,";
      data.forEach(function(line, index){
       csvLine = line.join(',');
       csvContent += index < data.length ? csvLine + "\n" : csvLine;
      }); 
      var encodedUri = encodeURI(csvContent);
      var linkedAnchor = document.createElement("a");
      linkedAnchor.setAttribute('href', encodedUri);
      linkedAnchor.setAttribute('download', name + '-users-' + moment().format('YYYYMMDD') + '.csv');
      document.body.appendChild(linkedAnchor);

      linkedAnchor.click();
      linkedAnchor.parentNode.removeChild(linkedAnchor);
    }
  };

  self.setHeadings = function() {
    self.review.availableHeadings = {
      'first_name': self.translations['edit.useradd.first_name'],
      'last_name': self.translations['edit.useradd.last_name'],
      'email': self.translations['edit.useradd.email'],
      'userid': self.translations['edit.useradd.userid'],
      'role': self.translations['edit.useradd.role'],
      'job_title': self.translations['edit.useradd.job_title'],
      'linked_locations': self.translations['manage.users.location'],
      'linked_departments': self.translations['global.forms.labels_department'],
      'linked_teams': self.translations['overview.settings.tabs_teams'],
      'linked_org_level': self.translations['overview.settings.tabs_org_levels'],
      'linked_grade': self.translations['overview.settings.tabs_grades'],
      'hired': self.translations['edit.useradd.hired'],
      'buddy_email': self.translations['edit.useradd.buddy_email'],
      'manager_email': self.translations['edit.useradd.manager_email'],
      'is_manager': self.translations['edit.useradd.is_manager'],
      'is_collaborator': self.translations['edit.useradd.is_collaborator'],
      'social_link': self.translations['edit.useradd.social_link'],
      'provisioning_status': self.translations['edit.useradd.provisioning_status'],
      'disable_assignments': self.translations['edit.useradd.disable_assignments'],
      'disable_assignment_completion': self.translations['edit.useradd.disable_assignment_completion'],
      'disable_assignment_removal': self.translations['edit.useradd.disable_assignment_removal'],
      'disable_assignment_edit': self.translations['edit.useradd.disable_assignment_edit'],
      'allow_user_creation': self.translations['edit.useradd.allow_user_creation'],
      'allow_user_edit': self.translations['edit.useradd.allow_user_edit'],
      'allow_password_reset': self.translations['edit.useradd.allow_password_reset'],
      'restricted_user_edit': self.translations['edit.useradd.restricted_user_edit'],
      'restricted_editable_fields': self.translations['edit.useradd.restricted_editable_fields'],
      'allow_adding_group_manager': self.translations['edit.useradd.allow_adding_group_manager'],
      'segmentation_required': self.translations['edit.useradd.segmentation_required'],
      'segmentation_subset': self.translations['edit.useradd.segmentation_subset'],
      'hide_options': self.translations['edit.useradd.hide_options'],
      'hide_non_managing_groups': self.translations['edit.useradd.hide_non_managing_groups'],
      'new_email': self.translations['edit.useradd.new_email'],
      'new_userid': self.translations['edit.useradd.new_userid'],
      'allow_direct_report_suspension': self.translations['edit.useradd.allow_direct_report_suspension']
    };

    self.match.availableHeadings = {
      'first_name': self.translations['edit.useradd.first_name'],
      'last_name': self.translations['edit.useradd.last_name'],
      'email': self.translations['edit.useradd.email'],
      'userid': self.translations['edit.useradd.userid'],
      'role': self.translations['edit.useradd.role'],
      'job_title': self.translations['edit.useradd.job_title'],
      'image': self.translations['edit.useradd.image'],
      'location_1': self.translations['edit.useradd.location_1'],
      'location_2': self.translations['edit.useradd.location_2'],
      'location_3': self.translations['edit.useradd.location_3'],
      'department_1': self.translations['edit.useradd.department_1'],
      'department_2': self.translations['edit.useradd.department_2'],
      'department_3': self.translations['edit.useradd.department_3'],
      'team': self.translations['edit.useradd.team'],
      'org_level': self.translations['edit.useradd.org_level'],
      'grade': self.translations['edit.useradd.grade'],
      'hired': self.translations['edit.useradd.hired'],
      'buddy_email': self.translations["edit.useradd.buddy_email"],
      'manager_email': self.translations["edit.useradd.manager_email"],
      'is_manager': self.translations['edit.useradd.is_manager'],
      'is_collaborator': self.translations['edit.useradd.is_collaborator'],
      'social_link': self.translations['edit.useradd.social_link'],
      'provisioning_status': self.translations['edit.useradd.provisioning_status'],
      'disable_assignments': self.translations['edit.useradd.disable_assignments'],
      'disable_assignment_completion': self.translations['edit.useradd.disable_assignment_completion'],
      'disable_assignment_removal': self.translations['edit.useradd.disable_assignment_removal'],
      'disable_assignment_edit': self.translations['edit.useradd.disable_assignment_edit'],
      'allow_user_creation': self.translations['edit.useradd.allow_user_creation'],
      'allow_user_edit': self.translations['edit.useradd.allow_user_edit'],
      'allow_password_reset': self.translations['edit.useradd.allow_password_reset'],
      'restricted_user_edit': self.translations['edit.useradd.restricted_user_edit'],
      'restricted_editable_fields': self.translations['edit.useradd.restricted_editable_fields'],
      'allow_adding_group_manager': self.translations['edit.useradd.allow_adding_group_manager'],
      'segmentation_required': self.translations['edit.useradd.segmentation_required'],
      'segmentation_subset': self.translations['edit.useradd.segmentation_subset'],
      'hide_options': self.translations['edit.useradd.hide_options'],
      'hide_non_managing_groups': self.translations['edit.useradd.hide_non_managing_groups'],
      'new_email': self.translations['edit.useradd.new_email'],
      'new_userid': self.translations['edit.useradd.new_userid'],
      'allow_direct_report_suspension': self.translations['edit.useradd.allow_direct_report_suspension']
    };

    if (self.flags.groups) {
      self.review.availableHeadings.groups = 'Groups';
      self.review.availableHeadings.managing_groups = 'Managing Groups';
      self.match.availableHeadings.groups = 'Groups';
      self.match.availableHeadings.managing_groups = 'Managing Groups';
    }

    if (self.flags.ecommerce) {
      self.review.availableHeadings.is_purchaser = self.translations['edit.useradd.is_purchaser'];
      self.match.availableHeadings.is_purchaser = self.translations['edit.useradd.is_purchaser'];
    }

    self.match.headingDescription = {
      'first_name': self.translations['edit.useradd.description.first_name'],
      'last_name': self.translations['edit.useradd.description.last_name'],
      'email': self.translations['edit.useradd.description.email'],
      'userid': self.translations['edit.useradd.description.userid'],
      'role': self.translations['edit.useradd.description.role'],
      'job_title': self.translations['edit.useradd.description.job_title'],
      'image': self.translations['edit.useradd.description.image'],
      'location_1': self.translations['edit.useradd.description.location_1'],
      'location_2': self.translations['edit.useradd.description.location_2'],
      'location_3': self.translations['edit.useradd.description.location_3'],
      'department_1': self.translations['edit.useradd.description.department_1'],
      'department_2': self.translations['edit.useradd.description.department_2'],
      'department_3': self.translations['edit.useradd.description.department_3'],
      'team': self.translations['edit.useradd.description.team'],
      'org_level': self.translations['edit.useradd.description.org_level'],
      'grade': self.translations['edit.useradd.description.grade'],
      'hired': self.translations['edit.useradd.description.hired'],
      'buddy_email': self.translations['edit.useradd.description.buddy_email'],
      'manager_email': self.translations['edit.useradd.description.manager_email'],
      'is_manager': self.translations['edit.useradd.description.is_manager'],
      'is_collaborator': self.translations['edit.useradd.description.is_collaborator'],
      'is_purchaser': self.translations['edit.useradd.description.is_purchaser'],
      'social_link': self.translations['edit.useradd.description.social_link'],
      'provisioning_status': self.translations['edit.useradd.description.provisioning_status'],
      'disable_assignments': self.translations['edit.useradd.description.disable_assignments'],
      'disable_assignment_completion': self.translations['edit.useradd.description.disable_assignment_completion'],
      'disable_assignment_removal': self.translations['edit.useradd.description.disable_assignment_removal'],
      'disable_assignment_edit': self.translations['edit.useradd.description.disable_assignment_edit'],
      'allow_user_creation': self.translations['edit.useradd.description.allow_user_creation'],
      'allow_user_edit': self.translations['edit.useradd.description.allow_user_edit'],
      'allow_password_reset': self.translations['edit.useradd.description.allow_password_reset'],
      'restricted_user_edit': self.translations['edit.useradd.description.restricted_user_edit'],
      'restricted_editable_fields': self.translations['edit.useradd.description.restricted_editable_fields'],
      'allow_adding_group_manager': self.translations['edit.useradd.description.allow_adding_group_manager'],
      'segmentation_required': self.translations['edit.useradd.description.segmentation_required'],
      'segmentation_subset': self.translations['edit.useradd.description.segmentation_subset'],
      'hide_options': self.translations['edit.useradd.description.hide_options'],
      'hide_non_managing_groups': self.translations['edit.useradd.description.hide_non_managing_groups'],
      'new_email': self.translations['edit.useradd.description.new_email'],
      'new_userid': self.translations['edit.useradd.description.new_userid'],
      'allow_direct_report_suspension': self.translations['edit.useradd.description.allow_direct_report_suspension'],
      'groups': 'Id values for groups previsously created in Continu',
      'managing_groups': 'Id values for groups previsously created in Continu. The user will be added as a manager of the group(s)'
    };
  };

  self.setHeadings();

  $translate([
    'global.forms.labels_department',
    'manage.users.location',
    'edit.useradd.missing_csv',
    'edit.useradd.success_csv',
    'edit.useradd.assign_fields',
    'edit.useradd.new_users',
    'edit.useradd.updated_users',
    'edit.useradd.errored_users',
    'edit.useradd.cancel_confirm',
    'edit.useradd.edited_valid',
    'edit.useradd.created_valid',
    'edit.useradd.already_added',
    'edit.useradd.already_updated',
    'edit.useradd.invalid_entry',
    'edit.useradd.pending_invite',
    'edit.useradd.success_verb',
    'edit.useradd.success_implement',
    'global.actions.create',
    'global.actions.update',
    'global.actions.added',
    'global.actions.updated',
    'edit.useradd.first_name',
    'edit.useradd.last_name',
    'edit.useradd.email',
    'edit.useradd.userid',
    'edit.useradd.role',
    'edit.useradd.job_title',
    'edit.useradd.image',
    'edit.useradd.location_1',
    'edit.useradd.location_2',
    'edit.useradd.location_3',
    'edit.useradd.department_1',
    'edit.useradd.department_2',
    'edit.useradd.department_3',
    'edit.useradd.team',
    'edit.useradd.org_level',
    'edit.useradd.grade',
    'edit.useradd.hired',
    'edit.useradd.manager_email',
    'edit.useradd.is_manager',
    'edit.useradd.is_collaborator',
    'edit.useradd.is_purchaser',
    'edit.useradd.social_link',
    'edit.useradd.provisioning_status',
    'edit.useradd.disable_assignments',
    'edit.useradd.disable_assignment_completion',
    'edit.useradd.disable_assignment_removal',
    'edit.useradd.disable_assignment_completion',
    'edit.useradd.disable_assignment_removal',
    'edit.useradd.disable_assignment_edit',
    'edit.useradd.allow_user_creation',
    'edit.useradd.allow_user_edit',
    'edit.useradd.allow_password_reset',
    'edit.useradd.restricted_user_edit',
    'edit.useradd.restricted_editable_fields',
    'edit.useradd.allow_adding_group_manager',
    'edit.useradd.segmentation_required',
    'edit.useradd.segmentation_subset',
    'edit.useradd.hide_options',
    'edit.useradd.hide_non_managing_groups',
    'edit.useradd.new_email',
    'edit.useradd.new_userid',
    'edit.useradd.allow_direct_report_suspension',
    'edit.useradd.description.first_name',
    'edit.useradd.description.last_name',
    'edit.useradd.description.email',
    'edit.useradd.description.userid',
    'edit.useradd.description.role',
    'edit.useradd.description.job_title',
    'edit.useradd.description.image',
    'edit.useradd.description.location_1',
    'edit.useradd.description.location_2',
    'edit.useradd.description.location_3',
    'edit.useradd.description.department_1',
    'edit.useradd.description.department_2',
    'edit.useradd.description.department_3',
    'edit.useradd.description.team',
    'edit.useradd.description.org_level',
    'edit.useradd.description.grade',
    'edit.useradd.description.hired',
    'edit.useradd.description.manager_email',
    'edit.useradd.description.is_manager',
    'edit.useradd.description.is_collaborator',
    'edit.useradd.description.is_purchaser',
    'edit.useradd.description.social_link',
    'edit.useradd.description.provisioning_status',
    'edit.useradd.description.disable_assignments',
    'edit.useradd.description.disable_assignment_completion',
    'edit.useradd.description.disable_assignment_removal',
    'edit.useradd.description.disable_assignment_completion',
    'edit.useradd.description.disable_assignment_removal',
    'edit.useradd.description.disable_assignment_edit',
    'edit.useradd.description.allow_user_creation',
    'edit.useradd.description.allow_user_edit',
    'edit.useradd.description.allow_password_reset',
    'edit.useradd.description.restricted_user_edit',
    'edit.useradd.description.restricted_editable_fields',
    'edit.useradd.description.allow_adding_group_manager',
    'edit.useradd.description.segmentation_required',
    'edit.useradd.description.segmentation_subset',
    'edit.useradd.description.hide_options',
    'edit.useradd.description.hide_non_managing_groups',
    'overview.settings.tabs_teams',
    'overview.settings.tabs_org_levels',
    'overview.settings.tabs_grades',
    'edit.useradd.buddy_email',
    'edit.useradd.description.manager_email',
    'edit.useradd.description.buddy_email',
    'edit.useradd.duplicate_rows',
    'edit.useradd.user_seats_limit_met'
  ]).then(function(translations){
    self.translations = translations;
    self.setHeadings();
  });

}]);
